"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _usePalette2 = _interopRequireDefault(require("../styles/PaletteProvider/usePalette"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _Text = _interopRequireDefault(require("../Text"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      colors = _useTheme.colors,
      spacing = _useTheme.spacing,
      fonts = _useTheme.fonts;

  var _usePalette = (0, _usePalette2.default)(),
      typography = _usePalette.typography;

  return {
    root: _objectSpread({}, fonts.headline4, {
      color: colors[typography.paragraphEmphasis],
      margin: spacing(2)
    }),
    inner: {
      marginLeft: spacing(1)
    }
  };
};

__signature__(useStyles, "useTheme{{ colors, spacing, fonts }}\nusePalette{{ typography }}", function () {
  return [_useTheme2.default, _usePalette2.default];
});

var ListItem = function ListItem(props) {
  var children = props.children;
  var classes = useStyles();
  return (0, _core.jsx)("li", {
    css: classes.root
  }, (0, _core.jsx)(_Text.default, {
    css: classes.inner
  }, children));
};

__signature__(ListItem, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = ListItem;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/List/Item.tsx");
  reactHotLoader.register(ListItem, "ListItem", "/builds/bA1zbJom/0/gojob/ui-bits/src/List/Item.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/List/Item.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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